import React from "react";
import ProjectsForm from "../../pages/projects/features/AddEditProject";
import Projects from "../../pages/projects/Projects";
import RoleManagement from "../../pages/RoleManagement/Role";
import AddEditRole from "../../pages/RoleManagement/features/AddEditRole";
import AddEditUser from "../../pages/user/features/AddEditUser";
import UserList from "../../pages/user/User";

import EmailTemplate from "../../pages/EmailTemplate/EmailTemplate";
import AddEditEmailTemplate from "../../pages/EmailTemplate/features/AddEditEmailTemplate";
import Customer from "../../pages/customer/Customer";
import AddEditCustomer from "../../pages/customer/features/AddEditCustomer";
import ProjectTeamManagement from "../../pages/projects/features/ProjectTeamManagement";
import AddUserPassword from "../../pages/user/features/AddUserPassword/AddUserPassword";
import Organization from "../../pages/organization/Organization";
import ProjectComponent from "../../pages/projects/features/ProjectComponent";
import ProjectVersion from "../../pages/projects/features/ProjectVersion";
import ProjectModule from "../../pages/projects/features/ProjectModule/ProjectModule";
import EditProjectComponent from "../../pages/projects/features/ProjectComponent/EditProjectComponent";
import ProjectStatus from "../../pages/projects/features/ProjectStatus";
import Teams from "../../pages/teams/Teams";
import AddEditTeams from "../../pages/teams/features/AddEditTeams";
import TeamMembers from "../../pages/teamMembers/TeamMembers";
import AddEditTeamMembers from "../../pages/teamMembers/features/AddEditTeamMembers";
import TaskPlanTab from "../../pages/taskPlan/features/TaskPlanTab";
import TeamProjects from "../../pages/teams/features/TeamProjects";
import TaskList from "../../pages/projects/features/TaskList";
import EditMyTask from "../../pages/editmytask/EditMyTask";
import calendar from "../../pages/calendar/Calendar";
import MyTeams from "../../pages/myTeams/MyTeams";
import ProjectTaskBoard from "../../pages/taskboard/TaskBoard";
import TeamBoard from "../../pages/teams/features/Team Board/TeamBoard";
import MyTimesheet from "../../pages/timesheet/myTimesheet/MyTimesheet";
import TimesheetLog from "../../pages/timesheet/timesheetLog/TimesheetLog";
import ReviewTimesheet from "../../pages/timesheet/reviewTimesheet/ReviewTimesheet";
import EmployeeTimesheet from "../../pages/timesheet/reviewTimesheet/feature/employeeTimesheet/EmployeeTimesheet";
import MyProjects from "../../pages/myProjects/MyProjects";

import MyProjectsTaskList from "../../pages/myProjects/features/myProjectsTaskList/MyProjectsTaskList";
import MyProjectsBacklog from "../../pages/myProjects/features/myProjectsBacklog/MyProjectsBacklog";
import MyTeamPlanning from "../../pages/myTeams/features/myTeamPlanning/MyTeamPlanning";
import MyTeamWorkReview from "../../pages/myTeams/features/myTeamWorkReview/MyTeamWorkReview";
import MyTeamTask from "../../pages/myTeams/features/myTeamTask/MyTeamTask";
import AllTask from "../../pages/myProjects/features/allTask/AllTask";

/*************************************** Test Pages ***************************************/
import MultiRowFormPage from "../../pages/test/MultiRowFormPage/MultiRowFormPage";
import MultiRowGroupFormPage from "../../pages/test/multiRowGroupFormPage/MultiRowGroupFormPage";
import SecurityPermission from "../../pages/RoleManagement/features/securityPermission/SecurityPermission";
import { securityKey } from "../../data/SecurityKey";
import Dashboard from "../../pages/dashboard/Dashboard";
import ProjectDomain from "../../pages/projectSettings/projectDomain/ProjectDomain";
import projectType from "../../pages/projectSettings/projectType/projectType";
import ProjectEnvironment from "../../pages/projects/features/ProjectEnvironment";
import SourceControl from "../../pages/projectSettings/sourceControl/SourceControl";
import ProjectSynergy from "../../pages/ProjectSynergy/ProjectSynergy";

import AddProjectSynergy from "../../pages/ProjectSynergy/components/addSynergy/AddProjectSynergy";
import EditSynergy from "../../pages/ProjectSynergy/components/synergyDetails/editSynergy/EditSynergy";
import StatusCategories from "../../pages/StatusCategories/statusCategories";
import ProfileSettings from "../../pages/profileSettings/ProfileSettings";
import TeamOverview from "../../pages/teamOverview/TeamOverview";
import ProjectStatusTest from "../../pages/projects/features/projectStatusTest/ProjectStatusTest";
import ProjectOverview from "../../pages/projectOverview/ProjectOverview";
import EmployeeWeeklyTimesheet from "../../pages/timesheet/reviewTimesheet/feature/employeeWeeklyTimesheet/EmployeeWeeklyTimesheet";
import PlanningStatus from "../../pages/PlanningStatus/PlanningStatus";
import TimesheetReport from "../../pages/timesheet/timesheetmodule/TimesheetReport";
import TimeSheetReportsDetails from "../../pages/timesheet/timeSheetReportsDetails/TimeSheetReportsDetails";
import NestedTableTestPage from "../../components/nestedTable/test/NestedTableTestPage";
import ProjectOverviewDetails from "../../pages/projectOverview/features/ProjectOverviewDetails";
import GroupManagement from "../../pages/groupManagement/GroupManagement";
import EditGroupManagement from "../../pages/groupManagement/features/EditGroupManagement";
import GroupWiseReports from "../../pages/reports/groupWiseReports/GroupWiseReports";
import TimeSheetReport from "../../pages/timesheet/employeeAudit/TimeSheetReport";
import EmployeeAuditReport from "../../pages/timesheet/employeeAudit/EmployeeAuditReport/EmployeeAuditReport";
// import GmailTemplate from "../../pages/Gmail Template/GmailTemplate";
// import AddGmailTemplate from "../../pages/Gmail Template/features/AddEditGmailTemplate";




const NotFound = React.lazy(() => import("../../pages/errors/NotFound"));

export const ComponentNavigation = [
  {
    id: "pageNotFound",
    path: "pageNotFound",
    exact: true,
    title: "",
    component: NotFound,
    text: "Page not found",
    securityKey: securityKey.COMMONPAGE,
    allowedRole: ['Admin', 'User', 'Team Leader'],
  },
  // Manage dashboard
  {
    id: "dashboard",
    path: "Dashboard",
    exact: true,
    title: "",
    component: Dashboard,
    text: "Dashboard",
    securityKey: securityKey.COMMONPAGE,
    allowedRole: ['Admin', 'User', 'Team Leader'],
  },
  // Manage Users
  {
    id: "users",
    path: "/admin/users",
    exact: true,
    title: "Users",
    component: UserList,
    hasParams: false,
    securityKey: securityKey.ADMIN,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "addEditUser",
    path: "/admin/addUser",
    exact: true,
    title: "UserForm",
    component: AddEditUser,
    hasParams: false,
    securityKey: securityKey.ADMIN,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "addEditUser",
    path: "/admin/editUser/:id",
    exact: true,
    title: "UserForm",
    component: AddEditUser,
    hasParams: false,
    securityKey: securityKey.ADMIN,
    allowedRole: ['Admin', 'Team Leader'],
  },

  // Manage Project
  {
    id: "Projects",
    path: "admin/projects",
    exact: true,
    title: "Projects",
    component: Projects,
    hasParams: false,
    securityKey: securityKey.PROJECTMANAGEMENT,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "addProjects",
    path: "admin/AddProject",
    exact: true,
    title: "AddProjects",
    component: ProjectsForm,
    hasParams: false,
    securityKey: securityKey.PROJECTMANAGEMENT,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "editProjects",
    path: "/admin/project/EditProject/:id",
    exact: true,
    title: "EditProjects",
    component: ProjectsForm,
    hasParams: false,
    securityKey: securityKey.PROJECTDETAILS,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "ProjectTeamManagementList",
    path: "/admin/project/ProjectTeamManagement/:id",
    exact: true,
    title: "ProjectTeamManagement",
    component: ProjectTeamManagement,
    hasParams: true,
    securityKey: securityKey.PROJECTTEAM,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "projectComponent",
    path: "/admin/project/ProjectComponent/:id",
    exact: true,
    title: "Project Component",
    component: ProjectComponent,
    hasParams: true,
    securityKey: securityKey.PROJECTCONFIG,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "ProjectComponent",
    path: "/admin/project/AddProjectComponent/",
    exact: true,
    title: "Project Component",
    component: ProjectComponent,
    hasParams: true,
    securityKey: securityKey.PROJECTCONFIG,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "ProjectComponent",
    path: "/admin/project/ProjectComponent/EditProjectComponent/:id",
    exact: true,
    title: "Project Component",
    component: EditProjectComponent,
    hasParams: true,
    securityKey: securityKey.PROJECTCONFIG,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "projectModule",
    path: "/admin/project/ProjectModule/:id",
    exact: true,
    title: "Project Module",
    component: ProjectModule,
    hasParams: true,
    securityKey: securityKey.PROJECTCONFIG,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "ProjectVersion",
    path: "/admin/project/ProjectVersion/:id",
    exact: true,
    title: "ProjectVersion",
    component: ProjectVersion,
    hasParams: true,
    securityKey: securityKey.PROJECTCONFIG,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "ProjectEnvironment",
    path: "/admin/project/ProjectEnvironment/:id",
    exact: true,
    title: "ProjectEnvironment",
    component: ProjectEnvironment,
    hasParams: true,
    securityKey: securityKey.PROJECTCONFIG,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "ProjectStatus",
    path: "/admin/project/ProjectStatus/:id",
    exact: true,
    title: "ProjectStatus",
    component: ProjectStatusTest,
    hasParams: true,
    securityKey: securityKey.PROJECTCONFIG,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "BacklogList",
    path: "/admin/project/BacklogList/:id",
    exact: true,
    title: "Backlog",
    component: TaskList,
    hasParams: true,
    securityKey: securityKey.COMMONPAGE,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "TaskBoard",
    path: "/admin/project/ProjectTaskBoard/:id",
    exact: true,
    title: "Task Board",
    component: ProjectTaskBoard,
    hasParams: true,
    securityKey: securityKey.COMMONPAGE,
    allowedRole: ['Admin', 'Team Leader'],
  },
  /*Manage Customer*/
  {
    id: "customerList",
    path: "/admin/customers",
    exact: true,
    title: "customerList",
    component: Customer,
    securityKey: securityKey.ADMIN,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "RoleManagement",
    path: "/admin/roles",
    exact: true,
    title: "Role Management",
    component: RoleManagement,
    hasParams: false,
    securityKey: securityKey.ADMIN,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "StatusCategories",
    path: "/admin/StatusCategories",
    exact: true,
    title: "Status Categories",
    component: StatusCategories,
    hasParams: false,
    securityKey: securityKey.ADMIN,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "PlanningStatus",
    path: "/admin/PlanningStatus",
    exact: true,
    title: "Planning Status",
    component: PlanningStatus,
    hasParams: false,
    securityKey: securityKey.ADMIN,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "addCustomer",
    path: "/admin/AddCustomer",
    exact: true,
    title: "CustomerForm",
    component: AddEditCustomer,
    hasParams: false,
    securityKey: securityKey.ADMIN,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "editCustomer",
    path: "/admin/EditCustomer/:id",
    exact: true,
    title: "CustomerForm",
    component: AddEditCustomer,
    hasParams: false,
    text: "Edit User",
    securityKey: securityKey.ADMIN,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "addRoleManagemet",
    path: "/AddRoleManagement",
    exact: true,
    title: "Role Management Form",
    component: AddEditRole,
    hasParams: false,
    securityKey: securityKey.ADMIN,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "editRoleManagemet",
    path: "/EditRoleManagement",
    exact: true,
    title: "Role Management Form",
    component: AddEditRole,
    hasParams: false,
    securityKey: securityKey.ADMIN,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "EmailTemplate",
    path: "/admin/emailTemplates",
    exact: true,
    title: "Email Template",
    component: EmailTemplate,
    hasParams: false,
    securityKey: securityKey.ADMIN,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "AddEmailTemplateForm",
    path: "/admin/AddEmailTemplate",
    exact: true,
    title: "EmailTemplateForm",
    component: AddEditEmailTemplate,
    hasParams: false,
    securityKey: securityKey.ADMIN,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "editEmailTemplateForm",
    path: "/admin/EditEmailTemplate/:id",
    exact: true,
    title: "EmailTemplateForm",
    component: AddEditEmailTemplate,
    hasParams: false,
    securityKey: securityKey.ADMIN,
    allowedRole: ['Admin', 'Team Leader'],
  },
  // {
  //   id: "GmailTemplate",
  //   path: "/admin/gmailTemplates",
  //   exact: true,
  //   title: "Gmail Templates",
  //   component: GmailTemplate,
  //   hasParams: true,
  //   securityKey: securityKey.COMMONPAGE,
  //   allowedRole: ['Admin', 'Team Leader'],
  // },
  // {
  //   id: "AddGmailTemplateForm",
  //   path: "/admin/AddGmailTemplate",
  //   exact: true,
  //   title: "GmailTemplateForm",
  //   component: AddGmailTemplate,
  //   hasParams: false,
  //   securityKey: securityKey.ADMIN,
  //   allowedRole: ['Admin', 'Team Leader'],
  // },
  // {
  //   id: "editGmailTemplateForm",
  //   path: "/admin/EditGmailTemplate/:id",
  //   exact: true,
  //   title: "GmailTemplateForm",
  //   component: AddGmailTemplate,
  //   hasParams: false,
  //   securityKey: securityKey.ADMIN,
  //   allowedRole: ['Admin', 'Team Leader'],
  // },
  {
    id: "AddUserPassword",
    path: "/AdduserPassword/:id",
    exact: true,
    title: "Add User Password",
    component: AddUserPassword,
    hasParams: false,
    securityKey: securityKey.COMMONPAGE,
    allowedRole: ['Admin', 'User', 'Team Leader'],
  },

  // Manage Organization Location
  {
    id: "Organization",
    path: "/admin/Organization",
    exact: true,
    title: "Organization",
    component: Organization,
    hasParams: false,
    securityKey: securityKey.ADMIN,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "ProjectModuel",
    path: "/admin/project/ProjectComponent/ProjectModuel/:id",
    exact: true,
    title: "Project Moduel",
    // component: ProjectModuel,
    component: ProjectModule,
    hasParams: false,
    securityKey: securityKey.ADMIN,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "Teams",
    path: "/admin/teams",
    exact: true,
    title: "Teams",
    component: Teams,
    hasParams: false,
    securityKey: securityKey.ADMIN,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "addEditTeams",
    path: "/admin/AddTeam",
    exact: true,
    title: "AddTeams",
    component: AddEditTeams,
    hasParams: false,
    securityKey: securityKey.ADMIN,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "addEditTeams",
    path: "/admin/teams/editTeam/:id",
    exact: true,
    title: "EditTeams",
    component: AddEditTeams,
    hasParams: false,
    securityKey: securityKey.ADMIN,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "TeamMembers",
    path: "/admin/teams/TeamMembers",
    exact: true,
    title: "Team Members",
    component: TeamMembers,
    hasParams: false,
    securityKey: securityKey.ADMIN,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "addEditTeamMembers",
    path: "/AddTeamMember",
    exact: true,
    title: "AddTeamMembers",
    component: AddEditTeamMembers,
    hasParams: false,
    securityKey: securityKey.ADMIN,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "addEditTeamMembers",
    path: "/editTeamMember/:id",
    exact: true,
    title: "EditTeamMembers",
    component: AddEditTeamMembers,
    hasParams: false,
    securityKey: securityKey.ADMIN,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "TeamProjects",
    path: "/admin/teams/TeamProjects",
    exact: true,
    title: "TeamProject",
    component: TeamProjects,
    hasParams: false,
    securityKey: securityKey.ADMIN,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "TeamPlanning",
    path: "/admin/teams/TeamPlanning/:id",
    exact: true,
    title: "TeamPlanning",
    component: MyTeamPlanning,
    hasParams: true,
    securityKey: securityKey.TEAMPLANNING,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "TeamPlanning",
    path: "/admin/teams/taskplan/:id",
    exact: true,
    title: "TeamPlanning",
    component: TaskPlanTab,
    hasParams: true,
    securityKey: securityKey.TEAMPLANNING,
    allowedRole: ['Admin', 'Team Leader'],
  },
  // {
  //   id: "Comments",
  //   path: "/task/Comments",
  //   exact: true,
  //   title: "taskComments",
  //   component: Comments,
  //   hasParams: false,
  // },
  {
    id: "teamBoard",
    path: "/admin/teams/teamBoard/:id",
    exact: true,
    title: "Team Board",
    component: TeamBoard,
    hasParams: false,
    securityKey: securityKey.COMMONPAGE,
    allowedRole: ['Admin', 'User', 'Team Leader'],
  },
  {
    id: "managetask",
    path: "/project/EditTask/:id",
    exact: true,
    title: "editTask",
    component: EditMyTask,
    hasParams: false,
    securityKey: securityKey.COMMONPAGE,
    allowedRole: ['Admin', 'User', 'Team Leader'],
  },
  {
    id: "managemytask",
    path: "/EditMyTask/:id",
    exact: true,
    title: "editmyTask",
    component: EditMyTask,
    hasParams: false,
    securityKey: securityKey.COMMONPAGE,
    allowedRole: ['Admin', 'User', 'Team Leader'],
  },
  {
    id: "calendar ",
    path: "/calendar",
    exact: true,
    title: "calendar",
    component: calendar,
    hasParams: false,
    securityKey: securityKey.COMMONPAGE,
    allowedRole: ['Admin', 'User', 'Team Leader'],
  },
  /** Time Sheet Menu Routes */
  {
    id: "myTimeSheet",
    path: "/TimeSheet/MyTimeSheet",
    exact: true,
    title: "My Time Sheet",
    component: MyTimesheet,
    hasParams: false,
    securityKey: securityKey.COMMONPAGE,
    allowedRole: ['Admin', 'User', 'Team Leader'],
  },
  {
    id: "timeSheetLog",
    path: "/TimeSheet/TimeSheetLog",
    exact: true,
    title: "Time Sheet Log",
    component: TimesheetLog,
    hasParams: false,
    securityKey: securityKey.COMMONPAGE,
    allowedRole: ['Admin', 'User', 'Team Leader'],
  },
  {
    id: "timeSheetlist",
    path: "TimeSheet/reports",
    exact: true,
    title: "Time Sheet List",
    component: TimesheetReport,
    hasParams: false,
    securityKey: securityKey.COMMONPAGE,
    allowedRole: ['Admin'],
  },
  {
    id: "reviewTimeSheet",
    path: "/TimeSheet/ReviewTimeSheet",
    exact: true,
    title: "Review Time Sheet",
    component: ReviewTimesheet,
    hasParams: false,
    securityKey: securityKey.REVIEWTIMESHEET,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "reviewEmpTimeSheet",
    path: "/TimeSheet/ReviewTimeSheet/Employee/:id",
    exact: true,
    title: "Review Employee Time Sheet",
    component: EmployeeTimesheet,
    hasParams: false,
    securityKey: securityKey.REVIEWTIMESHEET,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "reviewEmpTimeSheet",
    path: "/TimeSheet/ReviewTimeSheet/ReviewWeeklyTimesheet/:id",
    exact: true,
    title: "Review Employee Time Sheet",
    component: EmployeeWeeklyTimesheet,
    hasParams: false,
    securityKey: securityKey.REVIEWTIMESHEET,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "timesheetReports",
    path: "/admin/reports/TimeSheetReports",
    exact: true,
    title: "Time Sheet Reports Details",
    component: TimeSheetReportsDetails,
    hasParams: false,
    securityKey: securityKey.REVIEWTIMESHEET,
    allowedRole: ['Admin', 'Team Leader'],
  },
  /** ******************************Group Management****************************** */
  {
    id: "groupWiseReports",
    path: "/admin/reports/GroupWiseReports",
    exact: true,
    title: "Group Wise Reports",
    component: GroupWiseReports,
    hasParams: false,
    securityKey: securityKey.REVIEWTIMESHEET,
    allowedRole: ['Admin',  'Team Leader'],
  },

  // {
  //   id: "editGroupManagement",
  //   path: "/admin/reports/GroupReports/:id",
  //   exact: true,
  //   title: "Edit Group Management",
  //   component: EditGroupManagement,
  //   hasParams: false,
  //   securityKey: securityKey.REVIEWTIMESHEET,
  //   allowedRole: ['Admin', 'Team Leader'],
  // },

  {
    id: "groups",
    path: "/admin/groups",
    exact: true,
    title: "Group Management",
    component: GroupManagement,
    hasParams: false,
    securityKey: securityKey.REVIEWTIMESHEET,
    allowedRole: ['Admin',  'Team Leader'],
  },
  {
    id: "EditGroupManagement",
    path: "/admin/GroupDetails/:id",
    exact: true,
    title: "Edit Group Management",
    component: EditGroupManagement,
    hasParams: false,
    securityKey: securityKey.REVIEWTIMESHEET,
    allowedRole: ['Admin', 'Team Leader'],
  },

  /** ****************************** My Projects ****************************** */
  {
    id: "myProject",
    path: "/MyProjects",
    exact: true,
    title: "MyProjects",
    component: MyProjects,
    hasParams: false,
    securityKey: securityKey.COMMONPAGE,
    allowedRole: ['Admin', 'User', 'Team Leader'],
  },
  {
    id: "editProjects",
    path: "/myprojects/EditProject/:id",
    exact: true,
    title: "EditProjects",
    component: ProjectsForm,
    hasParams: false,
    securityKey: securityKey.PROJECTDETAILS,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "ProjectTeamManagementList",
    path: "/myprojects/ProjectTeamManagement/:id",
    exact: true,
    title: "ProjectTeamManagement",
    component: ProjectTeamManagement,
    hasParams: true,
    securityKey: securityKey.PROJECTTEAM,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "projectComponent",
    path: "/myprojects/ProjectComponent/:id",
    exact: true,
    title: "Project Component",
    component: ProjectComponent,
    hasParams: true,
    securityKey: securityKey.PROJECTCONFIG,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "ProjectComponent",
    path: "/myprojects/AddProjectComponent/",
    exact: true,
    title: "Project Component",
    component: ProjectComponent,
    hasParams: true,
    securityKey: securityKey.PROJECTCONFIG,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "ProjectComponent",
    path: "/myprojects/ProjectComponent/EditProjectComponent/:id",
    exact: true,
    title: "Project Component",
    component: EditProjectComponent,
    hasParams: true,
    securityKey: securityKey.PROJECTCONFIG,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "projectModule",
    path: "/myprojects/ProjectModule/:id",
    exact: true,
    title: "Project Module",
    component: ProjectModule,
    hasParams: false,
    securityKey: securityKey.ADMIN,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "ProjectVersion",
    path: "/myprojects/ProjectVersion/:id",
    exact: true,
    title: "ProjectVersion",
    component: ProjectVersion,
    hasParams: true,
    securityKey: securityKey.PROJECTCONFIG,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "ProjectStatus",
    path: "/myprojects/ProjectStatus/:id",
    exact: true,
    title: "ProjectStatus",
    component: ProjectStatus,
    hasParams: true,
    securityKey: securityKey.PROJECTCONFIG,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "ProjectEnvironment",
    path: "/myprojects/ProjectEnvironment/:id",
    exact: true,
    title: "ProjectEnvironment",
    component: ProjectEnvironment,
    hasParams: true,
    securityKey: securityKey.PROJECTCONFIG,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "ProjectSynergy",
    path: "/myprojects/ProjectSynergy/:id",
    exact: true,
    title: "ProjectSynergy",
    component: ProjectSynergy,
    hasParams: true,
    securityKey: securityKey.COMMONPAGE,
    allowedRole: ['Admin', 'User', 'Team Leader'],
  },
  {
    id: "addProjectSynergy",
    path: "/myprojects/addProjectSynergy/:id",
    exact: true,
    title: "Add Project Synergy",
    component: AddProjectSynergy,
    hasParams: true,
    securityKey: securityKey.COMMONPAGE,
    allowedRole: ['Admin', 'User', 'Team Leader'],
  },
  {
    id: "EditSynergy",
    path: "/myprojects/editsynergy/:id",
    exact: true,
    title: "",
    component: EditSynergy,
    text: "EditSynergy",
    securityKey: securityKey.COMMONPAGE,
    allowedRole: ['Admin', 'User', 'Team Leader'],
  },
  {
    id: "ProjectSynergy",
    path: "/admin/project/ProjectSynergy/:id",
    exact: true,
    title: "ProjectSynergy",
    component: ProjectSynergy,
    hasParams: true,
    securityKey: securityKey.COMMONPAGE,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "addProjectSynergy",
    path: "/admin/project/addProjectSynergy/:id",
    exact: true,
    title: "Add Project Synergy",
    component: AddProjectSynergy,
    hasParams: true,
    securityKey: securityKey.COMMONPAGE,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "EditSynergy",
    path: "/admin/project/editsynergy/:id",
    exact: true,
    title: "",
    component: EditSynergy,
    text: "EditSynergy",
    securityKey: securityKey.COMMONPAGE,
    allowedRole: ['Admin', 'User', 'Team Leader'],
  },
  {
    id: "myProjectTaskList",
    path: "/myprojects/tasklist/:id",
    exact: true,
    title: "MyProjectsTaskList",
    component: MyProjectsTaskList,
    hasParams: false,
    securityKey: securityKey.COMMONPAGE,
    allowedRole: ['Admin', 'User', 'Team Leader'],
  },
  {
    id: "myProjectBacklog",
    path: "/myprojects/backlog/:id",
    exact: true,
    title: "MyProjectsBacklog",
    component: MyProjectsBacklog,
    hasParams: false,
    securityKey: securityKey.COMMONPAGE,
    allowedRole: ['Admin', 'User', 'Team Leader'],
  },
  {
    id: "projecttaskboard",
    path: "/myprojects/projecttaskboard/:id",
    exact: true,
    title: "Project Task Board",
    component: ProjectTaskBoard,
    hasParams: false,
    securityKey: securityKey.COMMONPAGE,
    allowedRole: ['Admin', 'User', 'Team Leader'],
  },
  {
    id: "allTask",
    path: "/myprojects/AllTask/:id",
    exact: true,
    title: "All Task",
    component: AllTask,
    hasParams: false,
    securityKey: securityKey.COMMONPAGE,
    allowedRole: ['Admin', 'User', 'Team Leader'],
  },
   /** ********************************* Audit ********************************* */

   {
    id: "employeeReports",
    path: "/admin/employee/TimesheetReports",
    exact: true,
    title: "Employee Reports Details",
    component: TimeSheetReport,
    hasParams: false,
    securityKey: securityKey.ADMIN,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "employeeaudit",
    path: "/admin/employee/Audit",
    exact: true,
    title: "Employee Audit Reports ",
    component: EmployeeAuditReport,
    hasParams: false,
    securityKey: securityKey.ADMIN,
    allowedRole: ['Admin', 'Team Leader'],
  },


  /** ********************************* My Teams ********************************* */
  {
    id: "myTeams",
    path: "/myteams",
    exact: true,
    title: "Team User",
    component: MyTeams,
    hasParams: false,
    securityKey: securityKey.COMMONPAGE,
    allowedRole: ['Admin', 'User', 'Team Leader'],
  },
  {
    id: "addEditTeams",
    path: "/myteams/editTeam/:id",
    exact: true,
    title: "EditTeams",
    component: AddEditTeams,
    hasParams: false,
    securityKey: securityKey.TEAMDETAILS,
    allowedRole: ['Admin', 'User', 'Team Leader'],
  },
  {
    id: "myTeamTasks",
    path: "/myteams/teamtasks/:id",
    exact: true,
    title: "Planning",
    component: MyTeamTask,
    hasParams: true,
    securityKey: securityKey.COMMONPAGE,
    allowedRole: ['Admin', 'User', 'Team Leader'],
  },
  {
    id: "myTeamPlanning",
    path: "/myteams/TeamPlanning/:id",
    exact: true,
    title: "Planning",
    component: MyTeamPlanning,
    hasParams: true,
    securityKey: securityKey.TEAMPLANNING,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "TeamPlanning",
    path: "/myteams/taskplan/:id",
    exact: true,
    title: "TeamPlanning",
    component: TaskPlanTab,
    hasParams: true,
    securityKey: securityKey.TEAMPLANNING,
    allowedRole: ['Admin', 'Team Leader'],

  },
  {
    id: "teamBoard",
    path: "/myteams/teamboard/:id",
    exact: true,
    title: "team Board",
    component: TeamBoard,
    hasParams: true,
    securityKey: securityKey.COMMONPAGE,
    allowedRole: ['Admin', 'User', 'Team Leader'],
  },
  // {
  //   id: "teamWorkReview",
  //   path: "/myteams/review/:id",
  //   exact: true,
  //   title: "Team Work Review",
  //   component: MyTeamWorkReview,
  //   hasParams: true,
  //   securityKey: securityKey.COMMONPAGE,
  //   allowedRole: ['Admin', 'User', 'Team Leader'],
  // },
  {
    id: "teamOverview",
    path: "/myteams/teamOverview/:id",
    exact: true,
    title: "Team Overview",
    component: TeamOverview,
    hasParams: true,
    // Prefer TEAMOVERVIEW once role-permission seed includes 'TeamOverview'.
    // Until then COMMONPAGE keeps existing My Teams access working.
    securityKey: securityKey.COMMONPAGE,
    allowedRole: ['Admin', 'User', 'Team Leader'],
  },
  // {
  //   id: "teamWorkReview",
  //   path: "/tasklayout",
  //   exact: true,
  //   title: "Team Work Review",
  //   component: TaskLayout,
  //   hasParams: true,
  //   securityKey: securityKey.COMMONPAGE,
  //   allowedRole: ['Admin', 'User', 'Team Leader'],
  // },
  {
    id: 'securityPermission',
    path: '/admin/roles/SecurityPermission/:id',
    exact: true,
    title: 'Edit Permissions',
    component: SecurityPermission,
    hasParams: true,
    securityKey: securityKey.COMMONPAGE,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "ProjectType",
    path: "/admin/projectSettings/ProjectType",
    exact: true,
    title: "Project Type",
    component: projectType,
    hasParams: true,
    securityKey: securityKey.COMMONPAGE,
    allowedRole: ['Admin', 'User', 'Team Leader'],
  },
  {
    id: "ProjectDomain",
    path: "/admin/projectSettings/ProjectDomain",
    exact: true,
    title: "Project Domain",
    component: ProjectDomain,
    hasParams: true,
    securityKey: securityKey.COMMONPAGE,
    allowedRole: ['Admin', 'User', 'Team Leader'],
  },
  {
    id: "SourceControl",
    path: "/admin/projectSettings/sourceControl",
    exact: true,
    title: "Source Control",
    component: SourceControl,
    hasParams: true,
    securityKey: securityKey.COMMONPAGE,
    allowedRole: ['Admin', 'User', 'Team Leader'],
  },
  {
    id: "ProfileSettings",
    path: "/profileSettings",
    exact: true,
    title: "Profile Settings",
    component: ProfileSettings,
    hasParams: true,
    securityKey: securityKey.COMMONPAGE,
    allowedRole: ['Admin', 'User', 'Team Leader'],
  },
  {
    id: "TeamOverview",
    path: "/teamOverview",
    exact: true,
    title: "Team Overview",
    component: TeamOverview,
    hasParams: true,
    securityKey: securityKey.COMMONPAGE,
    allowedRole: ['Admin', 'User', 'Team Leader'],
  },

  // {
  //   id: "ProjectOverview",
  //   path: "/projectOverview",
  //   exact: true,
  //   title: "Project Overview",
  //   component: ProjectOverview,
  //   hasParams: true,
  //   securityKey: securityKey.ADMIN,
  //   allowedRole: ['Admin', 'Team Leader'],
  // },

  // {
  //   id: "ProjectOverviewDetails",
  //   path: "/ProjectOverviewDetails/:id",
  //   exact: true,
  //   title: "Project Overview Details",
  //   component: ProjectOverviewDetails,
  //   hasParams: true,
  //   securityKey: securityKey.ADMIN,
  //   allowedRole: ['Admin', 'Team Leader'],
  // },
  /********************************** Test Pages **********************************/
  {
    id: "MultiRowFormPage",
    path: "/MultiRowFormPage",
    exact: true,
    title: "",
    component: MultiRowFormPage,
    text: "MultiRowFormPage",
    securityKey: securityKey.COMMONPAGE,
    allowedRole: ['Admin', 'User', 'Team Leader'],
  },
  {
    id: "rowGroupFormPage",
    path: "/MultiRowGroupFormPage",
    exact: true,
    title: "",
    component: MultiRowGroupFormPage,
    text: "Row Group Form Page",
    securityKey: securityKey.COMMONPAGE,
    allowedRole: ['Admin', 'Team Leader'],
  },
  {
    id: "teamWorkReview",
    path: "/nestedTableTestPage",
    exact: true,
    title: "",
    component: NestedTableTestPage,
    text: "Row Group Form Page",
    securityKey: securityKey.COMMONPAGE,
    allowedRole: ['Admin', 'User', 'Team Leader'],
  },


];
